import { simpleZOptionsParser } from './simple-options-parser.js';
/**
 * @internal
 */
const defaultZOptionsParser = /*#__PURE__*/ simpleZOptionsParser();
/**
 * Parses command line options.
 *
 * @param args - Array of command line arguments
 * @param opts - Parser options.
 *
 * @returns A promise resolved to a map of recognized option names to arrays of their values.
 */
export function parseZOptions(args, opts) {
    return defaultZOptionsParser(args, opts);
}
//# sourceMappingURL=parse-options.js.map